import { format } from "date-fns";
import { ArrowRight } from "lucide-react";
import { GoListCardListProps } from "./types";
import { firestoreToDateTime } from "@/lib/utils";

export const GoListCardList: React.FC<GoListCardListProps> = ({
  cards,
  title,
  onEdit,
  showSum = false,
}) => {
  const totalHours = cards.reduce(
    (sum, card) =>
      typeof card.totalLaborHours?.estimatedLabor === "number"
        ? sum + card.totalLaborHours.estimatedLabor
        : sum,
    0
  );

  return (
    <div>
      <h3 className="mb-2 text-lg font-semibold">{title}</h3>
      <div className="overflow-x-auto rounded-lg bg-gray-100 p-2">
        <table className="min-w-full text-sm text-gray-600">
          <thead>
            <tr className="font-semibold">
              <th className="w-1/4 px-2 py-2 text-center">RO Number</th>
              <th className="w-1/4 px-2 py-2 text-center">Status</th>
              <th className="w-1/4 px-2 py-2 text-center">Time Out</th>
              <th className="w-1/4 px-2 py-2 text-center">Labor Hours</th>
              <th className="w-1/6 px-2 py-2 text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {cards.length === 0 ? (
              <tr>
                <td colSpan={5} className="py-4 text-center text-gray-500">
                  No ROs
                </td>
              </tr>
            ) : (
              <>
                {cards.map((card) => (
                  <tr
                    key={card.id}
                    className="border-b border-gray-200 bg-white last:border-b-0"
                  >
                    <td className="px-2 py-2 text-center font-medium">
                      {card.cardNumber ?? "N/A"}
                    </td>
                    <td className="px-2 py-2 text-center text-sm text-gray-500">
                      {card.currentContainer ?? "Unknown"}
                    </td>
                    <td className="px-2 py-2 text-center text-gray-600">
                      {format(
                        firestoreToDateTime(
                          card.promisedTime ?? new Date()
                        ) as Date,
                        "h:mm a"
                      )}
                    </td>
                    <td className="px-2 py-2 text-center text-gray-600">
                      {typeof card.totalLaborHours?.estimatedLabor === "number"
                        ? card.totalLaborHours.estimatedLabor
                        : "-"}
                    </td>
                    <td className="px-2 py-2 text-center">
                      <button
                        className="flex items-center justify-center gap-1 font-medium text-gray-600 focus:outline-none"
                        onClick={() => onEdit(card)}
                      >
                        View <ArrowRight size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
                {showSum && (
                  <tr className="bg-white font-bold">
                    <td className="px-2 py-2 text-center">SUM</td>
                    <td className="px-2 py-2 text-center"></td>
                    <td className="px-2 py-2 text-center"></td>
                    <td className="px-2 py-2 text-center">{totalHours}</td>
                    <td className="px-2 py-2 text-center"></td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
